import { createSelector } from "reselect";

import { dateSort } from "helpers/sort";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IStoreState } from "interfaces/storeState";
import { createRequestFetchingSelector } from "store/requests/selectors";

import { IWithLicensesState, selectDefaultMailboxUsed } from "../license";
import { IEntityCollectionState } from "../reducer";

import { EmailDomainStatus, IEmailDomain } from "./interfaces";

export interface IWithEmailDomainsState {
  entities: {
    emailDomains: IEntityCollectionState<IEmailDomain>;
  };
}

/**
 * @returns {IEmailDomain[]} all email domains (custom and helpdesk.com)
 */
export function selectEmailDomains(state: IWithEmailDomainsState): { [key: string]: IEmailDomain } {
  return state.entities.emailDomains;
}

/**
 * @returns {IEmailDomain[]} all fully custom domains (not helpdesk.com)
 */
export function selectCustomEmailDomains(state: IWithEmailDomainsState): IEmailDomain[] {
  return Object.values(state.entities.emailDomains).filter(({ dns }) => !!dns);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectDomains = createSelector(selectEmailDomains, (domains: any) =>
  // @ts-expect-error TS(18048)
  Object.values(domains).sort((a, b) => dateSort(a.createdAt, b.createdAt))
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectActiveDomainsMap = createSelector(selectEmailDomains, (emailDomains: any) =>
  Object.entries(emailDomains)
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    .filter(([, domain]) => domain.status === EmailDomainStatus.Active)
    .reduce((map, [key, domain]) => ({ [key]: domain, ...map }), {})
);

function isCustomDomain(domain: IEmailDomain): boolean {
  return !domain.name.endsWith(".helpdesk.com");
}

export function selectHelpdeskDomain(state: IWithEmailDomainsState): IEmailDomain | null {
  const emailDomains = Object.values(state.entities.emailDomains);
  if (emailDomains.length > 0) {
    return emailDomains.find(domain => !isCustomDomain(domain)) ?? null;
  }
  return null;
}

export function selectBestPossibleDomain(state: IWithEmailDomainsState): IEmailDomain | null {
  const allDomains = Object.values(state.entities.emailDomains);
  const customDomain = allDomains.find(domain => isCustomDomain(domain));
  const helpdeskDomain = allDomains.find(domain => !isCustomDomain(domain));

  return customDomain || helpdeskDomain || null;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectAnyEmailDomainUsed = createSelector(selectEmailDomains, (emailDomains: any) =>
  // @ts-expect-error TS(2345)
  Object.values(emailDomains).some((emailDomain: IEmailDomain) => emailDomain.flags.inboxUsed)
);

export function selectHasDomains(state: IWithEmailDomainsState): boolean {
  return Object.keys(state.entities.emailDomains).length > 0;
}

export function selectAreMailboxesSetUp(state: IWithEmailDomainsState & IWithLicensesState): boolean {
  return selectDefaultMailboxUsed(state);
}

export function selectEmailDomainLoading(state: IStoreState): boolean {
  return createRequestFetchingSelector(["CREATE_EMAIL_DOMAIN"])(state);
}

export function selectEmailDomainVerifyLoading(state: IStoreState): boolean {
  return createRequestFetchingSelector(["ENTITIES/EMAIL_DOMAIN/VERIFY"])(state);
}
